import { Phone } from "lucide-react";

export default function StickyCallButton() {
  return (
    <a
      href="tel:+19092335411"
      className="sticky-cta group"
      data-testid="sticky-call-button"
    >
      <div className="flex items-center gap-3 bg-[#D4AF37] text-black px-6 py-4 font-bold uppercase tracking-widest text-sm hover:bg-[#F3E5AB] transition-all duration-300 animate-pulse-gold">
        <Phone className="w-5 h-5" />
        <span className="hidden sm:inline">Call Raad</span>
      </div>
    </a>
  );
}
